import { jsxs as u, Fragment as h, jsx as s } from "react/jsx-runtime";
import { NavLink as L, Link as N } from "react-router-dom";
import { c as _ } from "../../index-C7ezJk5b.js";
import "../../base-BUIxijjU.js";
import "react";
import { cssX as o } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
var k = /* @__PURE__ */ ((r) => (r[r.Button = 0] = "Button", r[r.Link = 1] = "Link", r[r.NavLink = 2] = "NavLink", r[r.Anchor = 3] = "Anchor", r[r.HoverOptions = 4] = "HoverOptions", r))(k || {});
const w = ({
  type: r = 0,
  modifiers: c = [],
  onClick: i,
  isDisabled: n,
  link: a,
  children: e,
  className: m,
  style: d,
  testId: v,
  hoverContent: l,
  ...f
}) => {
  const t = {
    className: _(
      m,
      o("Button"),
      ...c,
      !i && !a && "is-no-click",
      n && "is-disabled",
      r === 4 && "is-options"
    ),
    "data-testid": v,
    onClick: i,
    style: d,
    children: /* @__PURE__ */ u(h, { children: [
      /* @__PURE__ */ s("div", { className: o("Button__inner"), children: e }),
      /* @__PURE__ */ s("div", { className: o("Button__hover"), children: l })
    ] }),
    ...f
  };
  switch (r) {
    case 0:
      return /* @__PURE__ */ s("button", { ...t, disabled: n });
    case 1:
      return /* @__PURE__ */ s(N, { to: a || "#", ...t });
    case 2:
      return /* @__PURE__ */ s(L, { to: a || "#", ...t });
    case 3:
      return /* @__PURE__ */ s("a", { target: "_blank", href: a || "#", ...t, rel: "noreferrer", children: e });
    case 4:
      return /* @__PURE__ */ s("div", { ...t });
    default:
      return null;
  }
};
export {
  k as ButtonType,
  w as default
};
